module.exports = __webpack_public_path__ + "static/media/gripfire.8d9b991a.svg";